import React from 'react';
import FormView from 'lib/form/form-view';
import Styled from 'styled';

import defaultStyles from './form-view.scss';

export default Styled(defaultStyles)(FormView);
